import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { SharedDataService } from '@teem/services/shared-data.service';
import { PLAN_TYPES } from '@teem/constants/subscription';
import { parseDate } from '@teem/helpers/functions';
import { Proposal } from '@teem/models/proposal';

@Component({
  selector: 'proposal-overview',
  templateUrl: './overview.component.html',
  styles: []
})
export class OverviewComponent implements OnInit {
  @Input() proposalNumber: number;
  @Input() stepDetails: any;
  @Output() triggerNext: EventEmitter<any> = new EventEmitter();
  @Output() triggerPrevious: EventEmitter<any> = new EventEmitter();
  @Output() saveProposal: EventEmitter<any> = new EventEmitter();
  activeTab: string = "project-detail";

  clientDetail: any;
  projectDetail: any;
  quote: any;
  terms: any;
  proposal: Proposal;
  userInfo: any;

  constructor(
    private sharedDataService: SharedDataService) { }

  ngOnInit(): void {

    for (let step of this.stepDetails) {

      switch (step.key) {
        case 'client-detail':
          this.clientDetail = step.data;
          break;
        case 'project-detail':
          this.projectDetail = step.data;
          break;
        case 'quotes':
          this.quote = step.data;
          break;
        case 'terms':
          this.terms = step.data;
          break;
      }
    }

    this.proposal = new Proposal({
      proposal_number: this.proposalNumber,
      client_id: this.clientDetail.id,
      title: this.projectDetail.title,
      description: this.projectDetail.description,
      comments: this.projectDetail.comments,
      links: this.projectDetail.links ? this.projectDetail.links : null,
      terms: this.terms ? this.terms : null
    });

    if (this.quote) {
      this.proposal.proposal_number = this.quote.proposal_number;
      this.proposal.quote_date = this.quote.quote_date;
      this.proposal.project_type = this.quote.project_type;
      this.proposal.tax_rate = this.quote.tax_rate;
      this.proposal.payment_info = this.quote.payment_info;
      this.proposal.total_amount = this.quote.total_amount;
      this.proposal.sub_total = this.quote.sub_total;
      this.proposal.deliverables = this.quote.deliverables;

      if (this.quote.save_default_payment_info) {
        this.proposal.save_default_payment_info = true;
      }
    }

    if (this.terms) {
      let termKeys = [];
      let termGroup: any;
      for (termGroup of Object.values(this.terms)) {
        termKeys.push({
          'key': termGroup.key,
          'title': termGroup.title,
          'terms': termGroup.terms
        });
      }

      this.proposal.terms = termKeys;
    }

    // Show/Hide whatsapp action as per pro plan
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        this.userInfo = data.userInfo;
      }
    })
  }

  isProPlan() {
    return this.userInfo && this.userInfo.subscription && this.userInfo.subscription.subscription_plan == PLAN_TYPES.pro;
  }

  switchTab(tab: string) {
    this.activeTab = tab;
  }

  getObjectValues(obj: any) {
    return obj ? Object.values(obj) : [];
  }

  deliverableCost(formValues) {
    if (formValues.rate && formValues.quantity) {
      return formValues.rate * formValues.quantity;
    }
    return 0;
  }

  save(action: string = 'save') {
    let values: any = Object.assign({}, this.proposal)

    if (this.projectDetail) {
      if (this.projectDetail.new_files && this.projectDetail.new_files.length)
        values.files = this.projectDetail.new_files;
    }

    this.saveProposal.emit({ values: values, action: action })
  }

}
